import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Axios from "axios";
import { CKEditor } from "ckeditor4-react";
import { editorConfig, SwalError } from "../../../../utils/constants";
import {
  create,
  getAll,
  getById,
  saveFile,
  update,
} from "../../../../utils/requests/dynamicReq";
import { ROUTES } from "../../../../utils/routes";
import Swal from "sweetalert2";
import { paths } from "../../../../utils/paths";
import { useDelete } from "../../../../utils/hooks/useDelete";
import { validate } from "./validations";
import { ArchiveUploader } from "../../../../components/FileUploader/ArchiveUploader";
import moment from "moment";
import DatePicker from "react-datepicker";

export const ManageTesis = () => {
  const { TESIS, INVESTIGATORS } = paths;
  const { id }: any = useParams();
  const { deleteIt } = useDelete();

  let { staffId, isAdmin } = useSelector(({ user }: any) => user);

  const history = useHistory();

  const [isCreate, setIsCreate] = useState(false);

  const [tituloDoctor, settituloDoctor] = useState("");
  const [doctorando, setdoctorando] = useState("");
  const [dniDoctorando, setdniDoctorando] = useState("");
  const [summaryEs, setsummaryEs] = useState("");
  const [summaryEn, setsummaryEn] = useState("");
  const [summaryVa, setsummaryVa] = useState("");
  const [fechaDefensa, setFechaDefensa] = useState(new Date());
  const [staff, setStaff] = useState([]);
  const [chosenStaffId, setChosenStaffId] = useState("");
  const [universidad, setUniversidad] = useState("");
  const [calificacion, setCalificacion] = useState("");
  const [premioExtra, setPremioExtra] = useState("");
  const [titulacion, setTitulacion] = useState("");
  const [cover, setCover] = useState("");
  const [pais, setPais] = useState("");
  const [idioma, setIdioma] = useState("");
  const [departamento, setDepartamento] = useState("");
  const [visibleWeb, setVisibleWeb] = useState("");

  const [pdf, setPdf] = useState("");
  const [message, setMessage] = useState("");
  const [allowedEdit, setAllowedEdit] = useState(false);

  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();

  useEffect(() => {
    isMountedRef.current = true;
    const { pathname } = history.location;
    pathname.includes("crear") ? setIsCreate(true) : loadData();
    loadStaticData();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadStaticData = async () => {
    try {
      let staff = isAdmin
        ? await getAll(INVESTIGATORS, source)
        : await getById(INVESTIGATORS, staffId, source);
      isMountedRef.current && isAdmin ? setStaff(staff) : setStaff(staff);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const loadData = async () => {
    try {
      let response = await getById(TESIS, id, source);
      isMountedRef.current && buildObjToLoad(response);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const buildObjToLoad = async (response: any) => {
    let allStaff = isAdmin
      ? await getAll(INVESTIGATORS, source)
      : await getById(INVESTIGATORS, staffId, source);
    const {
      doctorando,
      tituloDoctor,
      dniDoctorando,
      summaryVa,
      summaryEn,
      summaryEs,
      pdf,
      universidad,
      calificacion,
      premioExtra,
      visibleWeb,
      titulacion,
      cover,
      pais,
      idioma,
      departamento,
      fechaDefensa
    } = response;
    const startDateWithOffset = new Date(fechaDefensa);
    const startDateNoOffset = new Date(
      startDateWithOffset.getTime() -
        startDateWithOffset.getTimezoneOffset() * -60000
    );
    setdoctorando(doctorando);
    settituloDoctor(tituloDoctor);
    setdniDoctorando(dniDoctorando);
    setsummaryEs(summaryEs);
    setsummaryEn(summaryEn);
    setsummaryVa(summaryVa);
    setUniversidad(universidad);
    setCalificacion(calificacion);
    setPremioExtra(premioExtra ? "1" : "0");
    setTitulacion(titulacion);
    setCover(cover);
    setPais(pais);
    setIdioma(idioma);
    setPdf(pdf);
    setFechaDefensa(startDateNoOffset);
    setDepartamento(departamento);
    setVisibleWeb(visibleWeb ? "1" : "0");
    isAdmin ? setStaff(allStaff) : setStaff(allStaff);
    setChosenStaffId(response.staff?.id);
    if (isMountedRef.current) setAllowedEdit(true);
  };

  const handleSubmit = () => {
    const tesis = build();
    // const notValid = validate(tesis);
    // if (notValid) {
    //   setMessage(notValid);
    //   setTimeout(() => setMessage(""), 4000);
    //   return;
    // }
    let question = isCreate ? "crear una" : "editar esta";
    Swal.fire({
      icon: "question",
      text: `¿Quieres ${question} tesis?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => {
      isConfirmed && handleConfirmation(tesis);
    });
  };

  const handleConfirmation = (tesis: any) => {
    let createOrUpdate = isCreate
      ? create(TESIS, tesis, source)
      : update(TESIS, id, tesis, source);
    createOrUpdate
      .then(async ({ id }) => {
        if (typeof pdf !== "string") {
          const formData = new FormData();
          formData.append("document", pdf!);
          await saveFile(TESIS, id, "pdf", formData, source);
        }
        Swal.fire({
          icon: "success",
          text: `Tesis ${isCreate ? "creada" : "editada"} correctamente.`,
        });
        history.push(`${ROUTES.Tesis.all}`);
        setIsCreate(false);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          text: SwalError,
        });
      });
  };

  const build = () => ({
    tituloDoctor,
    doctorando,
    dniDoctorando,
    summaryEs,
    summaryEn,
    summaryVa,
    universidad,
    calificacion,
    premioExtra: premioExtra === "1" ? true : false,
    titulacion,
    cover,
    pais,
    idioma,
    departamento,
    visibleWeb: visibleWeb === "1" ? true : false,
    staffId: +chosenStaffId,
    fechaDefensa: moment(fechaDefensa).format("YYYY-MM-DD"),
  });

  const exists = isAdmin
    ? staff.some((c: any) => c.id === chosenStaffId)
    : staff.some((c: any) => c.staff.id === chosenStaffId);

  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Tesis
        </button>
      );
    }
    if (!isCreate || isAdmin) {
      return (
        <>
          <button className="baseBtn" onClick={handleSubmit}>
            Guardar cambios
          </button>
          <button
            className="smallBtn btn-danger ml-1"
            onClick={() => deleteIt(TESIS, id, ROUTES.Tesis.all, source)}
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      );
    }
  };

  return (
    <div className="centerPage">
      <div className="container-fluid p-4">
        <div className="row">
          <div className="col d-flex justify-summary-between">
            <div>
              <h3>Tesis </h3>
            </div>
          </div>
          {isAdmin || exists ? <div>{editDeleteButtons()}</div> : <></>}
        </div>
        <div className="row mt-4">
          <div className="col-12 text-center text-danger">
            <span>{message}</span>
          </div>
        </div>

        <div className="form-row mt-2">
          <div className="col">
            <small>*Título español</small>
            <input
              type="text"
              className="form-control"
              placeholder="*Título"
              value={tituloDoctor}
              onChange={({ target: { value } }) => {
                settituloDoctor(value);
              }}
            />
          </div>
          <div className="col">
            <small>Doctorando</small>
            <input
              type="text"
              className="form-control"
              placeholder="Doctorando"
              value={doctorando}
              onChange={({ target: { value } }) => {
                setdoctorando(value);
              }}
            />
          </div>
          <div className="col">
            <small>DNI Doctorando</small>
            <input
              type="text"
              className="form-control"
              placeholder="DNI Doctorando"
              value={dniDoctorando}
              onChange={({ target: { value } }) => {
                setdniDoctorando(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Universidad</small>
            <input
              type="text"
              className="form-control"
              placeholder="Universidad"
              value={universidad}
              onChange={({ target: { value } }) => {
                setUniversidad(value);
              }}
            />
          </div>
          <div className="col">
            <small>Calificación</small>
            <input
              type="text"
              className="form-control"
              placeholder="Calificación"
              value={calificacion}
              onChange={({ target: { value } }) => {
                setCalificacion(value);
              }}
            />
          </div>
          <div className="col">
            <small>Premio extra?</small>
            <select
              className="form-control input"
              value={premioExtra}
              onChange={({ target: { value } }) => {
                setPremioExtra(value);
              }}
            >
              <option value="">Seleccione una opción</option>
              <option value={0}>No</option>
              <option value={1}>Si</option>
            </select>
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Titulación</small>
            <input
              type="text"
              className="form-control"
              placeholder="Titulación"
              value={titulacion}
              onChange={({ target: { value } }) => {
                setTitulacion(value);
              }}
            />
          </div>
          <div className="col">
            <small>Cover</small>
            <input
              type="text"
              className="form-control"
              placeholder="Cover"
              value={cover}
              onChange={({ target: { value } }) => {
                setCover(value);
              }}
            />
          </div>
          <div className="col">
            <small>País</small>
            <input
              type="text"
              className="form-control"
              placeholder="País"
              value={pais}
              onChange={({ target: { value } }) => {
                setPais(value);
              }}
            />
          </div>
          <div className="col">
            <small>Idioma</small>
            <input
              type="text"
              className="form-control"
              placeholder="Idioma"
              value={idioma}
              onChange={({ target: { value } }) => {
                setIdioma(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Departamento</small>
            <input
              type="text"
              className="form-control"
              placeholder="Departamento"
              value={departamento}
              onChange={({ target: { value } }) => {
                setDepartamento(value);
              }}
            />
          </div>
          <div className="col">
            <small>Visible en la web?</small>
            <select
              className="form-control input"
              value={visibleWeb}
              onChange={({ target: { value } }) => {
                setVisibleWeb(value);
              }}
            >
              <option value="">Seleccione una opción</option>
              <option value="0">No</option>
              <option value="1">Si</option>
            </select>
          </div>
          <div className="col">
            <span>Fecha</span>
            <DatePicker
              className="form-control input"
              placeholderText="*Inicio"
              selected={fechaDefensa}
              onChange={(date:any) => setFechaDefensa(date)}
              dateFormat="dd MMMM, yyyy"
              isClearable={allowedEdit}
              locale="es"
              disabled={!allowedEdit}
            />
          </div>
        </div>

        <div className="form-row mt-2">
          <div className="col   justify-content-center">
            <ArchiveUploader handleFile={setPdf} archive={pdf} />
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col-6">
            {isAdmin || exists || isCreate ? (
              <>
                <small>*Seleccionar staff</small>
                <select
                  className="form-control input"
                  value={chosenStaffId}
                  onChange={({ target: { value } }) => {
                    setChosenStaffId(value);
                  }}
                >
                  <option value="">Seleccionar Investigador</option>
                  {isAdmin
                    ? staff?.map((c: any) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre} {c.apellidos}
                        </option>
                      ))
                    : staff?.map((c: any) => (
                        <option key={c.staff?.id} value={c.staff?.id}>
                          {c.staff?.nombre} {c.staff?.apellido}
                        </option>
                      ))}
                </select>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
        {(isCreate || allowedEdit) && (
          <>
            <div className="form-row mt-4">
              <div className="col">
                <small>*Texto en español</small>
                <CKEditor
                  initData={summaryEs}
                  config={editorConfig}
                  onChange={({ editor }: any) => {
                    setsummaryEs(editor.getData());
                  }}
                />
              </div>
            </div>
            <div className="form-row mt-4">
              <div className="col">
                <small>*Texto en inglés</small>
                <CKEditor
                  initData={summaryEn}
                  config={editorConfig}
                  onChange={({ editor }: any) => {
                    setsummaryEn(editor.getData());
                  }}
                />
              </div>
            </div>
            <div className="form-row mt-4">
              <div className="col">
                <small>*Texto en valenciano</small>
                <CKEditor
                  initData={summaryVa}
                  config={editorConfig}
                  onChange={({ editor }: any) => {
                    setsummaryVa(editor.getData());
                  }}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
